"use client";
import { usePathname } from "next/navigation";
import { PublicLayout } from "./PublicLayout";
import UserLayout from "./UserLayout";
import { useDictionaryInitializer } from "@/lib/hooks/useDictionaryInitializer";

interface MainLayoutProps {
  children: React.ReactNode;
}
export function MainLayout({ children }: MainLayoutProps) {
  useDictionaryInitializer();
  const discartRoutes = ["/admin", "/iniciar-sesion", "/registro-usuario", "/auth"];
  const pathname = usePathname();
  if (pathname !== "/") {
    if (pathname.startsWith("/admin") || discartRoutes.some((route) => pathname.startsWith(route))) {
      return <div className="!bg-gray-100">{children}</div>;
    }
  }
  if (pathname.startsWith("/usuario")) {
    return <UserLayout>{children}</UserLayout>;
  }

  return <PublicLayout>{children}</PublicLayout>;
}
